module.exports = ".about img {\n  max-width: 200px;\n  margin: 10px auto 20px;\n  display: table; }\n  @media (min-width: 800px) {\n    .about img {\n      float: left; } }\n  @media (min-width: 800px) {\n  .content-right {\n    width: calc(100% - 250px);\n    float: right; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.scss
// module id = ./src/app/about/about.component.scss
// module chunks = main